import { APIHOST } from '@/config/config'
// 生成手机验证码
export const GETPHONECODE = `${APIHOST}/auth/v3/phone_codes`
// 手机号验证码（登录)
// export const USERLOGIN = `${APIHOST}/auth/v1/users/login`

// 手机号登录或注册账户
export const CV_USERLOGIN_OR_SIGUP = `${APIHOST}/cv/v3/auth/phone_users/login_or_sign_up`
// 手机号登录或注册账户
export const HR_USERLOGIN_OR_SIGUP = `${APIHOST}/hr/v3/auth/phone_users/login_or_sign_up`

// 刷新jwt
export const REFRESHJWT = `${APIHOST}/auth/v3/jwts`
// 获取极验参数
// export const GEETESTS = `${APIHOST}/auth/v1/geetests `

// 获取微信二维码
export const GETWECHATQRCODE = `${APIHOST}/auth/v3/wechat_qr_codes`

// 检测是否扫码
export const RESULT_CV_WECHAT = `${APIHOST}/cv/v3/auth/wechat_scan_users/result`
export const RESULT_HR_WECHAT = `${APIHOST}/hr/v3/auth/wechat_scan_users/result`

// 获取账号设置（微信、手机、邮箱）
const GET_USERS_BIND_INFO = `${APIHOST}/auth/v3/users`

// 生成邮箱验证码
export const GETEMAILCODE = `${APIHOST}/cv/v3/auth/email_users/send_email_code`

// 获取小程序登录码
export const GETMICROQRCODE = `${APIHOST}/auth/v3/wechat_wxa_qrcode`


/*
  @ 生成手机验证码
  * premise
      without 无前提
      cv_account_registered 需是已注册cv用户
      cv_account_unregistered	需是未注册cv用户
      hr_account_registered 需是已注册hr用户
      hr_account_unregistered 需是未注册hr用户
  * phone_number 十一位手机号
*/
export const getPhoneCode = payload => {
  return window.$http({
    url: GETPHONECODE,
    method: 'POST',
    Authorization:false,
    data:payload
  })
}

/*
  @ 手机号验证码（登录)
  * account_type  cv_account/hr_account
  * phone_number
  * phone_code
*/
// export const userLogin = payload => {
//   return window.$http({
//     url: USERLOGIN,
//     method: 'POST',
//     Authorization:false,
//     data:payload
//   })
// }

/*
  @ 手机号登录或注册账户
  * account_type  cv_account/hr_account
  * phone_number
  * phone_code
*/
export const userLogin_or_sigup = ({account_type, data}) => {
  return window.$http({
    url: account_type==='cv_account' ? CV_USERLOGIN_OR_SIGUP : HR_USERLOGIN_OR_SIGUP ,
    method: 'POST',
    Authorization:false,
    data
  })
}

// 添加登录设备
export const addLoginDevice = ({data, jwt}) => {
  return window.$http({
    url: `${APIHOST}/cv/v3/auth/trusted_devices`,
    method: 'POST',
    Authorization: jwt,
    data
  })
}
// 获取登录设备列表
export const getDeviceList = ({params, jwt}) => {
  return window.$http({
    url: `${APIHOST}/cv/v3/auth/trusted_devices`,
    method: 'get',
    Authorization: jwt,
    params
  })
}
// 删除登录设备
export const delLoginDevice = (data, jwt) => {
  return window.$http({
    url: `${APIHOST}/cv/v3/auth/trusted_devices`,
    method: 'delete',
    Authorization: jwt,
    data
  })
}

/*
  @ 刷新jwt
*/
export const refreshJwt = payload => {
  return window.$http({
    url: REFRESHJWT,
    method: 'PUT',
    Authorization:true,
    data:payload
  })
}

/*
  @ 刷新jwt
*/
// export const geetests = payload => {
//   return window.$http({
//     url: GEETESTS,
//     method: 'get',
//     Authorization:true,
//     params:payload
//   })
// }

/*
  @ 获取微信二维码
  * expire_seconds 二维码有效时间（秒）
  * scene_str 场景值 {扫码业务}+{身份} 扫码业务：login 扫码业务(string):login 例如login_动态的uuid
  * account_type 账户种类 hr_account 或 cv_account
  * operation_type: 'login', //login/bind
*/
export const getWechatQrCode = payload => {
  return window.$http({
    url: GETWECHATQRCODE,
    method: 'GET',
    Authorization:false,
    params:payload
  })
}

/*
  @ 获取小程序登录码
*/
export const getMicroQrCode = payload => {
  return window.$http({
    url: GETMICROQRCODE,
    method: 'GET',
    Authorization: false,
    params: payload
  })
}

// 获取小程序扫码结果
export const getWechatScanResult = (data) => {
  return window.$http({
    url: `${APIHOST}/cv/v3/auth/wechat_scan_users/wxa_result`,
    method: 'GET',
    Authorization: false,
    params: data
  })
}

/*
  @ jwt验证，根据获取二维码时的 scene_str
  * scene_id 场景值 {扫码业务}+{身份} 扫码业务：login 扫码业务(string):login 例如login_动态的uuid bind
*/
export const result_wechat = ({account_type, params}) => {
  // console.log(params)
  // console.log(account_type)
  return window.$http({
    url: account_type==='cv_account' ? RESULT_CV_WECHAT : RESULT_HR_WECHAT ,
    method: 'GET',
    Authorization:false,
    params
  })
}

/*
  @ 获取账号设置（微信、手机、邮箱）
*/
export const get_users_bind_info = user_token => {
  return window.$http({
    url: `${GET_USERS_BIND_INFO}/${user_token}`,
    Authorization:false,
    method: 'GET',
  })
}

/*
  @ 生成邮箱验证码
  * premise
      without 无前提
      cv_account_registered 需是已注册cv用户
      cv_account_unregistered	需是未注册cv用户
      hr_account_registered 需是已注册hr用户
      hr_account_unregistered 需是未注册hr用户
  * email 邮箱
*/
export const getEmailCode = payload => {
  return window.$http({
    url: GETEMAILCODE,
    method: 'POST',
    Authorization: false,
    data: payload
  })
}

/*
  @ 校验邮箱验证码返回jwt等信息
  * email 邮箱
  * email_code 邮箱验证码
*/
export const user_email_login = payload => {
  return window.$http({
    url: `${APIHOST}/cv/v3/auth/email_users/verify_email_code`,
    method: 'POST',
    Authorization: false,
    data: payload
  })
}

/*
  @ 邮箱用户绑定手机号
  * jwt
  * phone_number 手机号
  * phone_code 手机号验证码
*/
export const user_email_bind_phone = payload => {
  return window.$http({
    url: `${APIHOST}/cv/v3/auth/old_users/bind_phone`,
    method: 'POST',
    Authorization: false,
    data: payload
  })
}

/*
  @ 获取领英授权地址
*/
export const getLinkedInUrl = () => {
  return window.$http({
    url: `${APIHOST}/cv/v3/auth/linked_in_users/url`,
    Authorization: false,
    method: 'GET'
  })
}

/*
  @ 验证领英code,并返回用户信息
  * code
*/
export const getLinkedInUserInfo = payload => {
  return window.$http({
    url: `${APIHOST}/cv/v3/auth/linked_in_users/verify_code`,
    method: 'POST',
    Authorization: false,
    data: payload
  })
}

/*
  @ 获取app扫码登录二维码
  * uuid 唯一标识
*/
export const getAppQrcode = payload => {
  return window.$http({
    url: `${APIHOST}/auth/v3/app_qr_codes`,
    Authorization: false,
    method: 'POST',
    data: payload
  })
}

/*
  @ 验证登录状态
  * uuid 唯一标识
*/
export const verifyLoginStatus = payload => {
  return window.$http({
    url: `${APIHOST}/auth/v3/app_login_verify`,
    Authorization: false,
    method: 'POST',
    data: payload
  })
}

// 获取简历手机号自动填充
export const getCvPhone = (cv_account_token) => {
  return window.$http({
    url: `${APIHOST}/cv/v3/cv_accounts/${cv_account_token}/cv_phone`,
    method: 'GET'
  })
}

/*
  @ 解绑/绑定用户信息
  * operation_type    bind_phone,unbind_phone,unbind_wechat
  * phone_number
  * phone_code
*/
export const update_users_bind_info = (data, user_token) => {
  return window.$http({
    url:  `${APIHOST}/auth/v3/users/${user_token}`,
    method: 'PUT',
    data
  })
}
/***
 * 绑定手机号弹窗
 * ***/
export const getBindMessage = (cv_account_token) => {
  return window.$http({
    url:  `${APIHOST}/cv/v3/auth/cv_accounts/${cv_account_token}`,
    method: 'GET'
  })
}
